export default "__VITE_ASSET__wlzXUkuR__"